import React from 'react';

const Search = props => (
  <div>
    <h4 className='mt-4 mb-2 labelInfo'>Buscar cliente :</h4>
    <div className='row'>
      <div className='col-md-6 mb-3 mt-2'>
        <div className='fSearch'>
      
          <input
            type='text'
            className='fSearch-search form-control'
            placeholder='datos cliente'
            name='searchInput'
            value={props.searchInput}
            onChange={props.onChangeValue}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                props.search(props.searchOption, props.searchInput);
              }
            }}
          />
          <button
            className='btn btn-dark fSearch-go'
            type='button'
            onClick={() => props.search(props.searchOption, props.searchInput)}
          >
            <i className='ion-android-arrow-forward' />
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default Search;



// WEBPACK FOOTER //
// ./src/pages/modals/CambiarCliente/Search.js